module.exports = __webpack_public_path__ + "static/media/354JamesPBrawleyDrNW_2018-06-11_72.7ca6f9ba.jpg";